import { useEffect } from "react";
import { usePageTitle } from "../contexts/PageTitleContext";

export const useSetPageTitle = (title) => {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    if (title) {
      setPageTitle(title);
    }
    return () => {
      setPageTitle("");
    };
  }, [title, setPageTitle]);
};
